import React from "react";

const Hero = () => {
  return (
    <div className="relative flex items-center bg-hero-pattern bg-cover bg-center backimg h-[669px]">
      <div className="absolute inset-0 bg-white/30 backdrop-blur-[2px]" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-2xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold pb-14 textbig">
            Mehr Zeit für Harmonie & Balance
            <br />
            {/* <span className="relative textbig">
              Unterstützig für d'Seel
            </span> */}
          </h1>

          <p className="text-lg sm:text-xl text-[#8DA399] pb-14 max-w-xl spantexti">
          Akzeptiere was ist und Erschaffe was du sein oder haben willst
          </p>

          {/* <a href="#services"
            className="bg-[#F5F5F5] text-[#5D6473] font-bold hover:bg-[#F5F5F5] rounded-full px-8 py-5 text-lg" style={{fontSize:'18px'}}
          >
            Lerne üsi Dienstleistungen kenne
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default Hero;